import { 
    REQUEST_HOME_INFO,
    RECEIVED_HOME_INFO,
    CLEAR_HOME_INFO,
    ERROR_HOME_INFO,
} from './../constants';


export default function(state={}, action) {
    switch(action.type){
        case REQUEST_HOME_INFO:
            return {
                ...state,
                loading: true,
                err:false,
                errInfo: null,
                status: null
            }
        case RECEIVED_HOME_INFO:
            return {
                ...state,
                loading: false,
                res: action.res,
                err: false,               
                sliderImages: action.res && action.res.slider_images && action.res.slider_images,
                examPreferences: action.res && action.res.examPreferences && action.res.examPreferences,
                testOfUsers: action.res && action.res.tests_of_user && action.res.tests_of_user,
                testByAdmin: action.res && action.res.tests_by_admin && action.res.tests_by_admin,
                userDetails: action.res && action.res.user_details && action.res.user_details
            }
        case ERROR_HOME_INFO: 
            return {
                ...state,
                err: true,
                errInfo: action.err && action.err.response && action.err.response.data && action.err.response.data.message,
                loading: false,               
            }
        case CLEAR_HOME_INFO:
            return { }
        default: return state
    }
}